import _ from 'lodash';
import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';

// actions
import * as actions from './../../../../actions/actions';

class Datepicker extends React.Component {
    constructor(props) {
        super(props);
        this.onDateChange = this.onDateChange.bind(this);
    }

    onDateChange(date) {
        this.props.actions.setDateWidgetValue(this.props.widget.id, date);

        if (this.props.mode === 'CLIENT') {
            if (_.isEmpty(date)) {
                this.props.actions.deleteResult(this.props.activeId);
            } else {
                this.props.actions.saveResult(this.props.activeId, this.props.widget.type, date);
            }
        }
    }

    render() {
        const { widget } = this.props;
        return (
            <div>
            {
                (_.isEmpty(widget.value)) ?
                    <DatePicker onChange={this.onDateChange} placeholderText="Click to select a date" /> :
                    <DatePicker onChange={this.onDateChange} placeholderText="Click to select a date" selected={widget.value} />
            }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    mode: state.app.mode,
    results: state.results,
    activeId: state.pages.activeId,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Datepicker.propTypes = {
    mode: PropTypes.string.isRequired,
    results: PropTypes.oneOfType([
        PropTypes.object.isRequired,
        PropTypes.array.isRequired,
    ]),
    activeId: PropTypes.number.isRequired,
    widget: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Datepicker);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/Widgets/Datepicker/Datepicker.jsx